import { ChatPersonalization } from '../../../../domain/chat/models/ChatPersonalization';
import { SavedPersona } from '../../../../domain/chat/models/SavedPersona';
import { SavedPrompt } from '../../../../domain/chat/models/SavedPrompt';
import {
    ProGPTChatPersonalizationDto,
    ProGPTPersonaDto,
    ProGPTPromptDto,
} from '../dtos/responses/ProGPTChatPersonalizationDto';

const toTimestamp = (value?: string | number): number | undefined => {
    if (value === undefined || value === null) {
        return undefined;
    }

    if (typeof value === 'number') {
        return value;
    }

    const timestamp = new Date(value).getTime();

    return Number.isNaN(timestamp) ? undefined : timestamp;
};

export const mapProGPTPersonaDtoToModel = (dto: ProGPTPersonaDto): SavedPersona => ({
    id: dto.id,
    title: dto.title,
    content: dto.content,
    createdDate: toTimestamp(dto.createdDate) ?? Date.now(),
});

export const mapProGPTPromptDtoToModel = (dto: ProGPTPromptDto): SavedPrompt => ({
    id: dto.id,
    text: dto.text,
    agentId: dto.agentId,
    createdDate: toTimestamp(dto.createdDate) ?? Date.now(),
    modifiedDate: toTimestamp(dto.modifiedDate),
});

export const mapProGPTChatPersonalizationDtoToModel = (
    dto: ProGPTChatPersonalizationDto,
): ChatPersonalization => ({
    userId: dto.userId,
    personas: dto.personas.map(mapProGPTPersonaDtoToModel),
    prompts: dto.prompts.map(mapProGPTPromptDtoToModel),
});
